// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerLeft":"Footer_footerLeft__Izh62","footerIcons":"Footer_footerIcons__eNYCa","socialIcon":"Footer_socialIcon__+HSoA"};